export const START_DWOLLA_FETCH = "START_DWOLLA_FETCH";
export const START_DWOLLA_SUCCESS = "START_DWOLLA_SUCCESS";
export const START_DWOLLA_ERROR = "START_DWOLLA_ERROR";
export const SAVE_TRANSFER_DOC_FETCH = "SAVE_TRANSFER_DOC_FETCH";
export const SAVE_TRANSFER_DOC_SUCCESS = "SAVE_TRANSFER_DOC_SUCCESS";
export const SAVE_TRANSFER_DOC_ERROR = "SAVE_TRANSFER_DOC_ERROR";
export const SEND_EMAIL_RECEIPT_FETCH = "SEND_EMAIL_RECEIPT_FETCH";
export const SEND_EMAIL_RECEIPT_SUCCESS = "SEND_EMAIL_RECEIPT_SUCCESS";
export const SEND_EMAIL_RECEIPT_ERROR = "SEND_EMAIL_RECEIPT_ERROR";
